import type { EventSettings } from '../services/events';

export interface AutoApprovalEvent {
  settings: Partial<Pick<EventSettings, 'autoApprove' | 'coApprovalEnabled'>>;
  autoApprovalHold?: boolean;
}

export function attendeeSongSkipsApproval(event: AutoApprovalEvent): boolean {
  return event.settings.autoApprove === true && !event.settings.coApprovalEnabled && event.autoApprovalHold !== true;
}

export function prizePickSkipsApproval(event: AutoApprovalEvent): boolean {
  return !event.settings.coApprovalEnabled && event.autoApprovalHold !== true;
}
